import script from "./OAuthCallback.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthCallback.vue?vue&type=script&setup=true&lang=js"

import "./OAuthCallback.vue?vue&type=style&index=0&id=a5af2b88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5af2b88"]])

export default __exports__